import Swiper from 'swiper/bundle';
import { someCookiesAllowed, allowSomeCookies } from './cookies';

var currentContentSliders = [];
var currentLightboxSliders = [];

const initSliders = function initSliders()
{
  initDefaultSlideshow();
  initCarrouselSliders();
  initGalleryLightbox();
  initVideoLightbox();
  initCareerSliders();
  initEventSliders();
  initIconsSliders();

  setTimeout(initCollectionSlidersSlim, 500);
  setTimeout(initCollectionSliders, 500);
  setTimeout(initCollectionImageSliders, 500);
  setTimeout(initCollectionVideoSliders, 500);
  setTimeout(initContentSliders, 500);
  setTimeout(initIconsSliders, 500);
  setTimeout(initStrapsSlider, 500);

  initNavLangSlider();
}


function initDefaultSlideshow()
{

  const swiperItems = document.querySelectorAll(".default-slideshow .swiper-slide");

  if (!swiperItems) {
    return false;
  }

  const swiper = new Swiper('.default-slideshow', {
    loop: true,
    navigation: {
      nextEl: '.default-slideshow .swiper-button-next',
      prevEl: '.default-slideshow .swiper-button-prev',
    },
  });


  // disables the slider in case that there is only 1 item
  if (swiperItems.length === 1) {
    $('.full-width-slideshow').addClass( "disabled" );
    $('.default-slideshow .swiper-wrapper').addClass( "disabled" );
    $('.default-slideshow .swiper-pagination').addClass( "disabled" );
  }
}

function initNavLangSlider()
{
  const swiper = new Swiper('.swiper-nav-lang',
  {
    slidesPerView: 4,
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
      draggable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 7,
      },
    }
  });
}

function initCollectionSliders()
{
  var swiper = new Swiper('.swiper-collection',
  {
    slidesPerView: 1,
    spaceBetween: 0,
    grabCursor : true,
    scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 4,
      }
    }

  });

  const slideshows = document.querySelectorAll(".swiper-collection");
  for (let i=0; i < slideshows.length; i++) {
    if (typeof slideshows[i].id === 'string' && slideshows[i].id) {
      let id = "#"+slideshows[i].id;
      if ($(id+ ' .swiper-pagination span').length === 1) {
        $(id+ ' .swiper-pagination').addClass( "disabled" );
      }
    }
  }
}


function initCollectionSlidersSlim()
{
  var swiper = new Swiper('.swiper-collection--slim',
  {
    slidesPerView: 1,
    spaceBetween: 0,
    grabCursor : true,
    scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 6,
      }
    }

  });

  const slideshows = document.querySelectorAll(".swiper-collection--slim");
  for (let i=0; i < slideshows.length; i++) {
    if (typeof slideshows[i].id === 'string' && slideshows[i].id) {
      let id = "#"+slideshows[i].id;
      if ($(id+ ' .swiper-pagination span').length === 1) {
        $(id+ ' .swiper-pagination').addClass( "disabled" );
      }
    }
  }
}

function initCarrouselSliders()
{
  new Swiper('.swiper-carrousel',
  {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 30,
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable : true
      // }
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
      },
  });


  new Swiper('.swiper-carrousel-121',
  {
      slidesPerView: 'auto',
      centeredSlides: false,
      spaceBetween: 30,
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable : true
      // }
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
      },
  });


  if (window.innerWidth > 1024) {
    $(".swiper-carrousel-121 .grab-on-mobile").click(collection121Action);
    $(".swiper-carrousel-121 .grab-on-mobile").hover(collection121Action);
  }
}

function collection121Action( event )
{
  event.preventDefault();
  const itemId = $(this).attr("data-item");
  $(".swiper-slide").removeClass("swiper-slide-next");
  $(this).parents(".swiper-slide").addClass("swiper-slide-next");
  // console.log(itemId);
  $(".carrousel-item-desc").removeClass("active");
  $(".carrousel-item-desc--item-"+itemId).addClass("active");
}

function initContentSliders()
{
  const contentSliders = document.querySelectorAll(".content-slider");

  if (!contentSliders) {
    return false;
  }

  let sliderIds = [];
  contentSliders.forEach( function(element){
     sliderIds.push(element.id)
  });

  if (sliderIds.length) {
    for(let i=0; i<sliderIds.length;i++) {
      let sliderPrefix = "#"+sliderIds[i];

        currentContentSliders[sliderPrefix] = new Swiper(sliderPrefix+' .gallery-top', {
          autoHeight: false,
          spaceBetween: 10,
          draggable: false,
          speed: 400,
          watchSlidesProgress: false,
          thumbs: {
            swiper: makeTabSlider(sliderPrefix)
          },
          on: {
            reachEnd: function () {
              document.querySelector(sliderPrefix+" .gallery-thumbs").classList.add("end-reached");
            },
            fromEdge: function () {
              document.querySelector(sliderPrefix+" .gallery-thumbs").classList.remove("end-reached");
            },
            // // click: function () {
            //   this.slideNext();
            // }
          }
        });
    }
  }
}


function makeTabSlider( sliderPrefix )
{
  const tabSlider = new Swiper(

    sliderPrefix+' .gallery-thumbs',
    {
      grabCursor : true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      roundLengths: true,
      slidesPerView: 'auto',
      navigation: {
        nextEl: sliderPrefix+' .gallery-thumbs .swiper-button-next',
        prevEl: sliderPrefix+' .gallery-thumbs .swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
        draggable: false
      },
      on: {
        activeIndexChange: function (swiper, event) {
          if (typeof swiper.clickedIndex === 'undefined' || typeof swiper.clickedIndex === 'number' && (swiper.clickedIndex - swiper.realIndex) <=1 ) {
            currentContentSliders[sliderPrefix].slideTo(swiper.realIndex);
          }
        }
      },
      breakpoints:
      {
        640: {
          slidesPerView: 1,
        },
        768: {
          freeMode: true,
          slidesPerView: 'auto',
        },
      }
    }
  );

  return tabSlider;
}


function initCollectionImageSliders()
{
  const imageSliders = document.querySelectorAll(".swiper-image-collection");

  if (!imageSliders) {
    return false;
  }


  let sliders = [];
  imageSliders.forEach( function(element){
    let sliderId = '#'+element.id;

    sliders[sliderId] = new Swiper(sliderId+'.swiper-image-collection', {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 400,
      grabCursor : true,
      scrollbar: {
          el: '.swiper-scrollbar',
          hide: false,
      },
      navigation: {
        nextEl: sliderId+' .swiper-button-next',
        prevEl: sliderId+' .swiper-button-prev',
      },
     breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 32,
        },

        768: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      }

    });
  });


  for (let i=0; i < imageSliders.length; i++) {
    if (typeof imageSliders[i].id === 'string' && imageSliders[i].id) {
      let id = "#"+imageSliders[i].id;
      if ($(id+ ' .swiper-pagination span').length === 1) {
        $(id+ ' .swiper-pagination').addClass( "disabled" );
      }
    }
  }
}


function initCollectionVideoSliders()
{
  const videoSliders = document.querySelectorAll(".swiper-video-collection");

  if (!videoSliders) {
    return false;
  }

  let sliders = [];
  videoSliders.forEach( function(element){
    let sliderId = '#'+element.id;

    sliders[sliderId] = new Swiper(sliderId+'.swiper-video-collection', {
      slidesPerView: 1,
      spaceBetween: 40,
      speed: 400,
      grabCursor : true,
      scrollbar: {
          el: '.swiper-scrollbar',
          hide: false,
      },
      navigation: {
        nextEl: sliderId+' .swiper-button-next',
        prevEl: sliderId+' .swiper-button-prev',
      },
      // breakpoints: {
        // 640: {
        //   slidesPerView: 2,
        //   spaceBetween: 32,
        // },
      // }

    });
  });


  const slideshows = document.querySelectorAll(".swiper-video-collection");
  for (let i=0; i < slideshows.length; i++) {
    if (typeof slideshows[i].id === 'string' && slideshows[i].id) {
      let id = "#"+slideshows[i].id;
      if ($(id+ ' .swiper-pagination span').length === 1) {
        $(id+ ' .swiper-pagination').addClass( "disabled" );
      }
    }
  }
}


function initGalleryLightbox()
{
  // init event listenrs to show lightboxes
  const imgLightboxes = document.querySelectorAll('.go-lightbox-btn');
  if (imgLightboxes.length) {
    imgLightboxes.forEach( function(el) {
        el.addEventListener('click', function(event) {
          event.preventDefault();
          const section = event.target.closest(".image-gallery");
          const sliderId = section.dataset.sliderid;
          if (section && typeof section.dataset.sliderid === 'string') {
            section.classList.add("active");
            const orientation = (window.innerHeight > window.innerWidth) ? 'is-vertical' : 'is-horizontal';
            section.classList.add(orientation);

            let button = event.target;
            if (typeof event.target.dataset.index==='undefined') {
              button = event.target.parentNode;
            }
            startSliderInLightbox(section.dataset.sliderid, button.dataset.index);
          }
        })
    });
  }

  const closeLightboxBtns = document.querySelectorAll('.close-lightbox');
  if (closeLightboxBtns.length) {
    closeLightboxBtns.forEach(function(el){
      el.addEventListener('click', function(event) {
        event.preventDefault();
        const imageGalleries = document.querySelectorAll('.image-gallery');
        if (imageGalleries) {
          imageGalleries.forEach(function(gallery){
            gallery.classList.remove('active');
          });
        }
      });
    });
  }

}

function startSliderInLightbox(sliderId, goToIndex)
{
  if (typeof currentLightboxSliders[sliderId] === 'undefined') {
      // _log('init: '+sliderId);
      currentLightboxSliders[sliderId] = new Swiper('#lightboxSlider-'+sliderId, {
          spaceBetween: 0,
          draggable: false,
          speed: 0,
          pagination: false,
          watchSlidesProgress: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          thumbs: {
            swiper: makeLightboxNavigation(sliderId)
          },
          on: {
            // click: function ()
            // {
            //   this.slideNext();
            // },
            activeIndexChange : function(swiper)
            {
              updateStatus(sliderId, swiper.activeIndex);
            }
          }
        });

      const elements = document.querySelectorAll('.open-full-screen');
      elements.forEach(function(el){
        el.addEventListener('click', function(event){

          let expBtn = event.target;
          if (typeof expBtn.dataset.rel==='undefined') {
            expBtn = expBtn.closest('.open-full-screen');
          }
          // _log(expBtn);
          openFullScreen(expBtn.dataset.rel);
        });

      });

  }

  currentLightboxSliders[sliderId].slideTo(goToIndex);
  updateStatus(sliderId, goToIndex);
}


function openFullScreen(elementId)
{
  var elem = document.querySelector("#"+elementId+" .fullscreen-only");
  // _log("elementId");
  // _log(elementId);
  // _log("#lightboxSlider-"+ elementId);

  // const elem = document.querySelector(elementId);
  // const elem = document.getElementById(elementId);
  // _log(elem);

  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.webkitRequestFullscreen) { /* Safari */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) { /* IE11 */
    elem.msRequestFullscreen();
  }
}


function updateStatus(sliderId, goToIndex)
{
  document.getElementById('status-'+sliderId).innerText=parseInt(goToIndex)+1;
}


function makeLightboxNavigation(sliderId)
{
  const navId = '#lightboxNav-'+ sliderId;
  const tabSlider = new Swiper(
    navId,
    {
      grabCursor : true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
      roundLengths: true,
      navigation: {
        nextEl: navId+' .swiper-button-next',
        prevEl: navId+' .swiper-button-prev',
      },
      freeMode: true,
      slidesPerView: 'auto',
    }
  );

  return tabSlider;
}



function initVideoLightbox()
{

  const videoLightboxes = document.querySelectorAll('.go-video-lightbox-btn');
  let element = null;
  if (videoLightboxes.length) {
    for(let i=0;i<videoLightboxes.length;i++) {
      videoLightboxes[i].addEventListener("click", function(event) {
        event.preventDefault();

        element = event.target;
        if (typeof element.dataset.iframe === 'undefined') {
          element = event.target.closest(".go-video-lightbox-btn");
        }

        showVideoPlayer(element);
        // if (someCookiesAllowed()) {
        //   showVideoPlayer(element);
        // } else {
        //   showCookieModal(element);
        // }

        return false;
      });
    }


    // enable close button
    const closeLightboxBtns = document.querySelectorAll('.close-lightbox');
    if (closeLightboxBtns.length) {
      closeLightboxBtns.forEach(function(el){
        el.addEventListener('click', function(event) {
          event.preventDefault();
          hideVideoPlayer(element);
        });
      });
    }
  }
}

function video_url_parser(url){
  var regExp = /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/;
  var match = url.match(regExp);

  return (match&&match[6].length > 8)? match[6] : false;
}


function showVideoPlayer(element)
{
  const section = element.closest(".video-gallery");
  const sliderId = section.dataset.sliderid;

  if (section && typeof sliderId === 'string') {
    section.classList.add("active");
    // orientation maybe not needed for video gallerys
    // const orientation = (window.innerHeight > window.innerWidth) ? 'is-vertical' : 'is-horizontal';

    var vidElement = document.getElementById('lightboxVideo-'+sliderId);

    let iframeSrc = element.dataset.iframe;   

    if( iframeSrc ) {
      if (!someCookiesAllowed()) {
        iframeSrc = iframeSrc.replace('autoplay=1', 'autoplay=1&dnt=1');
      }
    } else {
      const href = element.getAttribute("href");

      if( href.indexOf('youtube') !== -1 ) {
        const videoId = video_url_parser(href);
        if( videoId ) {
          iframeSrc = `<iframe width="420" height="315" src="https://www.youtube.com/embed/${videoId}"></iframe>`;
        }  
      }

      if( href.indexOf('vimeo') !== -1 ) {
        const videoId = video_url_parser(href);
        if( videoId ) {
          iframeSrc = `<iframe src="https://player.vimeo.com/video/${videoId}" width="420" height="315"></iframe>
          `;
        }      
      } 
      // Handle Tencent cloud videos and generic MP4 videos
      if( href.indexOf('vod-qcloud.com') !== -1 || href.match(/\.(mp4|mov|webm)$/) ) {
        iframeSrc = `<video width="100%" height="100%" controls autoplay playsinline>
          <source src="${href}" type="video/mp4">
          Your browser does not support the video tag.
        </video>`;
      }
    }

    vidElement.innerHTML = iframeSrc;
  }
}


function hideVideoPlayer(element)
{
  // stop playing video
  const elements = document.querySelectorAll(".goLightbox__show--video");
  elements.forEach(function(el){
    el.innerHTML = 'VIDEO';
  });

  // hide lightbox
  const imageGalleries = document.querySelectorAll('.lightbox-section');
  if (imageGalleries) {
    imageGalleries.forEach(function(gallery){
      gallery.classList.remove('active');
    });
  }
}


function showCookieModal(element)
{
  if ( typeof element.dataset.iframe === "string") {
    $(".js_allowSoMeCookies").unbind();
    const modalId = '#'+element.dataset.modal;
    $(modalId).modal('toggle');

    $(".js_allowSoMeCookies").click( function(){
      allowSomeCookies();
      $(modalId).modal('toggle');
      showVideoPlayer(element);
    });
  }
}

function initCareerSliders()
{
  const careerSliders = document.querySelectorAll(".swiper-career");

  if (!careerSliders) {
    return false;
  }

  let sliders = [];
  careerSliders.forEach( function(element){
    let sliderId = '#'+element.id;

    sliders[sliderId] = new Swiper(sliderId+'.swiper-career', {
      slidesPerView: 'auto',
      spaceBetween: 40,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      speed: 400,
      grabCursor : true,
      scrollbar: {
        el: sliderId+' .swiper-scrollbar',
        hide: false,
      },
    });
  });
}

function initEventSliders()
{
  const eventSliders = document.querySelectorAll(".swiper-event");

  if (!eventSliders) {
    return false;
  }

  let sliders = [];
  eventSliders.forEach( function(element){
    let sliderId = '#'+element.id;

    sliders[sliderId] = new Swiper(sliderId+'.swiper-event', {
      slidesPerView: 'auto',
      spaceBetween: 40,
      speed: 400,
      grabCursor : true,
      scrollbar: {
        el: sliderId+' .swiper-scrollbar',
        hide: false,
      },

    });
  });
}

function initIconsSliders()
{
  const iconSliders = document.querySelectorAll(".swiper-icons");

  if (!iconSliders) {
    return false;
  }

  let sliders = [];
  iconSliders.forEach( function(element){
    let sliderId = '#'+element.id;

    sliders[sliderId] = new Swiper(sliderId+'.swiper-icons', {
      slidesPerView: 'auto',
      spaceBetween: 32,
      speed: 400,
      grabCursor : true,
      scrollbar: {
        el: sliderId+' .swiper-scrollbar',
        hide: false,
      },
      navigation: {
        nextEl: sliderId+' .swiper-button-next',
        prevEl: sliderId+' .swiper-button-prev',
      },
    });
  });
}

function initStrapsSlider()
{
  const swiper = new Swiper("#straps-slider", {
    slidesPerView: 1,
    breakpoints: {
      640: {
        slidesPerView: 3
      },
      1280: {
        slidesPerView: 5
      },
    },
    centeredSlides: true,
    slideToClickedSlide: true,
    spaceBetween: 0,
    speed: 400,
    hashNavigation: {
      watchState: true,
    },
    grabCursor : true,
    scrollbar: {
      el: '#straps-slider .swiper-scrollbar',
      hide: false,
    },
    navigation: {
      nextEl: '#straps-slider .swiper-button-next',
      prevEl: '#straps-slider .swiper-button-prev',
    },
  });
}


export { initSliders };